import React from "react"

export default function Loader() {
  return (
    <div className="h-screen w-screen fixed bg-black bg-opacity-25 flex flex-row justify-center items-center">
      <div className="loader"></div>
    </div>
  )
}